import { render, staticRenderFns } from "./Shoulder.vue?vue&type=template&id=35028022&"
import script from "./Shoulder.vue?vue&type=script&lang=js&"
export * from "./Shoulder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports